import React, { useState } from 'react';
import styled from 'styled-components/macro';
import I18n from '../../../helper/Localization';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { getTheme } from '@fluentui/react';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';

const Headline = styled.div`
    font-size: 26px;
    font-weight: bold;
    color: ${(props) => props.fontColor};
`;

const PanelHeader = styled.div`
    display: flex;
    width: 100%;
    padding: 20px;
    justify-content: flex-start;
    flex-direction: column;
`;

const PanelBody = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    height: 100%;
    padding: 0 20px;
    min-width: max-content;
`;

const PanelFooter = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 10px 20px;
    position: relative;
`;

const FlexEnd = styled.div`
    display: flex;
    padding-top: 5px;
    justify-content: flex-end;
`;

const RadioButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    gap: 16px;

    .ms-ChoiceField-field::after {
        width: 12px;
        height: 12px;
        left: 4px;
        border-width: 6px;
        top: 4px;
    }
`;

/**
 * Interceptor dialog to choose between manual test entry or PDF upload.
 */
export const ManualTestInterceptorDialog = (props) => {
    const [selectedOption, setSelectedOption] = useState('manual');

    const theme = getTheme();
    const cancelButtonStyles = {
        root: {
            border: 'unset',
        },
    };

    const radioOptions = [
        {
            key: 'manual',
            text: I18n.get().t('ManualTestDialog_SelectionManual'),
        },
        {
            key: 'pdf',
            text: I18n.get().t('ManualTestDialog_SelectionPdf'),
        },
    ];

    /**
     * Closes the interceptor dialog.
     */
    const closeDialog = () => {
        setSelectedOption('manual');
        props.toggleHideDialog();
    };

    /**
     * Handles the continue action based on selected option.
     */
    const handleContinue = () => {
        closeDialog();
        
        if (selectedOption === 'manual') {
            props.onOpenManualTestDialog();
        } else if (selectedOption === 'pdf') {
            props.onOpenPdfTestDialog();
        }
    };

    /**
     * Handles radio button selection change.
     */
    const handleOptionChange = (ev, option) => {
        setSelectedOption(option.key);
    };

    /**
     * Body of the panel
     */
    const onRenderBody = () => {
        return (
            <PanelBody>
                <RadioButtonContainer>
                    <ChoiceGroup
                        options={radioOptions}
                        onChange={handleOptionChange}
                        selectedKey={selectedOption}
                        required={true}
                    />
                </RadioButtonContainer>
            </PanelBody>
        );
    };

    /**
     * Footer content of the panel.
     */
    const onRenderFooterContent = () => (
        <PanelFooter>
            <FlexEnd>
                <DefaultButton 
                    styles={cancelButtonStyles} 
                    onClick={closeDialog} 
                    text={I18n.get().t('ManualTestDialog_Cancel')} 
                />
                <PrimaryButton 
                    onClick={handleContinue} 
                    text="Weiter" 
                />
            </FlexEnd>
        </PanelFooter>
    );

    /**
     * Header content of the panel.
     */
    const onRenderHeader = () => (
        <PanelHeader>
            <Headline fontColor={theme.palette.black}>{I18n.get().t('ManualTestDialog_Headline')}</Headline>
        </PanelHeader>
    );

    return (
        <Panel
            isOpen={!props.hidden}
            isFooterAtBottom={true}
            onDismiss={closeDialog}
            isLightDismiss
            type={PanelType.custom}
            customWidth={'max-content'}
            closeButtonAriaLabel={I18n.get().t('DebtorPanel_Close')}
            onRenderHeader={onRenderHeader}
            onRenderBody={onRenderBody}
            onRenderFooter={onRenderFooterContent}
        />
    );
};